import React, { useState, useCallback, useEffect, } from "react";
import { v4 as uuidv4 } from "uuid";
import { Title } from "./Title";
import { Tooltip } from "./Tooltip";
import { Link } from "./Link";
import { setIcon } from "./utils/icons";
import { classNames } from "./utils/classNames";
import { THEME } from "./theming/theming";
import { useIconClasses } from "./theming/icons";
export var SubSection = function (_a) {
    var title = _a.title, tooltip = _a.tooltip, open = _a.open, children = _a.children, _b = _a.titleLevel, titleLevel = _b === void 0 ? "h3" : _b, _c = _a.display, display = _c === void 0 ? "removed" : _c, _d = _a.arrowPosition, arrowPosition = _d === void 0 ? "right" : _d, id = _a.id, _e = _a.hideBorderBottom, hideBorderBottom = _e === void 0 ? false : _e, _f = _a.helpLink, helpLink = _f === void 0 ? undefined : _f, _g = _a.warningMessage, warningMessage = _g === void 0 ? undefined : _g;
    var _h = useState(!open ? "closed" : "open"), show = _h[0], setShow = _h[1];
    var toggleOpen = useCallback(function () {
        if (show === "open") {
            setShow("closed");
        }
        else {
            setShow("opening");
        }
    }, [show, setShow]);
    useEffect(function () {
        if (show === "opening") {
            setTimeout(function () { return setShow("open"); }, 100);
        }
    }, [show]);
    var componentId = id || uuidv4();
    var borderClass = hideBorderBottom ? "no-border-bottom" : "";
    var _j = setIcon("exclamationSign"), iconType = _j.iconType, iconValue = _j.iconValue;
    var iconClasses = useIconClasses(iconType, THEME.palette.warning.base.color);
    var subSectionTitle = (React.createElement(Title, { titleLevel: titleLevel, extraClass: titleLevel === "span" ? "sub-section-header--title" : "" }, title));
    var subSectionTitleWithToolTip = tooltip ? (React.createElement(Tooltip, { content: tooltip, tooltipId: uuidv4(), dataTestId: "iconTooltip" }, subSectionTitle)) : (subSectionTitle);
    var warning = warningMessage ? (React.createElement(React.Fragment, null,
        React.createElement("span", { className: classNames(iconClasses.icon, iconType, "".concat(iconType, "-").concat(iconValue), "pl-5") }),
        warningMessage)) : null;
    var helpLinkElement = helpLink ? (React.createElement("div", { className: "float-right pr-2" },
        React.createElement(Link, { type: helpLink.type, label: helpLink.title, url: helpLink.url }))) : null;
    return (React.createElement("div", { className: "sub-section", id: componentId ? "".concat(componentId, "-sub-section") : undefined },
        open !== undefined && (React.createElement("div", { className: "sub-section-header ".concat(borderClass), onClick: function () { return toggleOpen(); }, role: "button", onKeyPress: function () { return toggleOpen(); }, tabIndex: 0, "aria-expanded": show === "open", "aria-controls": componentId },
            open !== undefined && arrowPosition === "left" && (React.createElement("span", { className: "sub-section-header-indicator sub-section-header-indicator--left glyphicon glyphicon-chevron-right ".concat(show) })),
            subSectionTitleWithToolTip,
            warning,
            open !== undefined && arrowPosition === "right" && (React.createElement("span", { className: "sub-section-header-indicator sub-section-header-indicator--right glyphicon glyphicon-chevron-right ".concat(show) })),
            helpLinkElement)),
        open === undefined && (React.createElement("div", { className: "sub-section-header ".concat(borderClass) },
            subSectionTitleWithToolTip,
            warning,
            helpLinkElement)),
        React.createElement("div", { className: "sub-section--components ".concat(show, " ").concat(open !== undefined ? "display-".concat(display) : ""), id: componentId },
            display === "removed" &&
                (show === "opening" || show === "open" || open === undefined) &&
                children,
            display === "hidden" && React.createElement("div", null, children))));
};
export var useSubSection = function (open) {
    var _a = useState(open ? "closed" : undefined), show = _a[0], setShow = _a[1];
    var toggleOpen = useCallback(function () {
        if (show === "open") {
            setShow("closed");
        }
        else {
            setShow("opening");
        }
    }, [show, setShow]);
    useEffect(function () {
        if (show === "opening") {
            setTimeout(function () { return setShow("open"); }, 100);
        }
    }, [show]);
    return { show: show, toggleOpen: toggleOpen };
};
